/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 老项目域名地址
 * khglUrl: 客户管理域名地址
 * dicUrl : 字典服务器地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * welUrl :默认欢迎页
 *
 */

 let baseUrl = ''
 let mhbaseUrl = ''
 let baseUrlFile = ''
 let noticeBaseUrl = ''
 let workflowBaseUrl = ''
 let downloadUrl = ''
 let uploadUrl = ''
 let rootUrl = ''
 let kkFileViewUrl = ''
 let attachmentUrl = ''
 const iconfontVersion = ['567566_r22zi6t8noas8aor']
 const iconfontUrl = `//at.alicdn.com/t/font_$key.css`
 const codeUrl = `${baseUrl}/code`
 const env = process.env
 if (env.NODE_ENV === 'development') {
    // baseUrl = `http://bba.loiot.com:8303/api-schedule` // 开发环境地址   
    // mhbaseUrl = 'http://bba.loiot.com:8303/api-portal' // 门户产品]
    // baseUrlFile = 'http://bba.loiot.com:8303/api-file' // 文件服务地址
    // rootUrl  = "http://bba.loiot.com:8303/"
    // attachmentUrl = 'http://bba.loiot.com:8303/api-portal'
     baseUrl=`http://localhost:8205/api-forest`
     mhbaseUrl = 'http://bba.loiot.com:91/api-portal' // 门户产品
     baseUrlFile = 'http://bba.loiot.com:91/api-file' // 文件服务地址
     rootUrl  = "http://bba.loiot.com:91/"
     attachmentUrl = 'http://localhost:8205/api-forest'

     noticeBaseUrl = 'http://114.55.102.254:8010/api-notice' //消息服务地址
     workflowBaseUrl = 'http://114.55.102.254:8050/api-workflow' //工作流服务地址
     kkFileViewUrl = 'http://bba.loiot.com:5209/onlinePreview?url=' //文件预览地址
     
 } else if (env.NODE_ENV === 'production') {
     baseUrl = `http://bba.loiot.com:8303/api-schedule` // 生产环境地址
     mhbaseUrl = 'http://bba.loiot.com:8303/api-portal' // 门户产品
     baseUrlFile = 'http://bba.loiot.com:8303/api-file' // 文件服务地址
     noticeBaseUrl = 'http://bba.loiot.com:8303/api-notice' //消息服务地址
     workflowBaseUrl = 'http://bba.loiot.com:8303/api-workflow' //工作流服务地址
     rootUrl  = "http://bba.loiot.com:8303/"
     kkFileViewUrl = 'http://bba.loiot.com:5209/onlinePreview?url=' //文件预览地址
     attachmentUrl = 'http://bba.loiot.com:8303/api-portal'
 } else if (env.NODE_ENV === 'test') {
    baseUrl = `http://127.0.0.1:8801/api-schedule` // 开发环境地址
    mhbaseUrl = 'http://bba.loiot.com:8303/api-portal' // 门户产品
    baseUrlFile = 'http://bba.loiot.com:8303/api-file' // 文件服务地址
    noticeBaseUrl = 'http://114.55.102.254:8010/api-notice' //消息服务地址
    workflowBaseUrl = 'http://114.55.102.254:8050/api-workflow' //工作流服务地址
    rootUrl  = "http://bba.loiot.com:8303/"
    kkFileViewUrl = 'http://bba.loiot.com:5209/onlinePreview?url=' //文件预览地址
    attachmentUrl = 'http://bba.loiot.com:8303/api-portal'
 }

 uploadUrl  = baseUrlFile + '/api/file/upload'             //文件上传路径
 downloadUrl  = baseUrlFile + '/api/file/download?filePath=' //文件下载路径

 export function setKkFileViewUrl(url) {
    kkFileViewUrl = url;
}
export function getKkFileViewUrl() {
     return kkFileViewUrl;
}
export function setRootUrl(url) {
    rootUrl = url;
}
export function getRootUrl() {
     return rootUrl;
}
export function setDownloadUrl(url) {
    downloadUrl = url;
}
export function getDownloadUrl() {
    return downloadUrl;
}
export function setUploadUrl(url) {
    uploadUrl = url;
}
export function getUploadUrl() {
    return uploadUrl;
}
export function setBaseUrl(url) {
    baseUrl = url;
}
export function getBaseUrl() {
    return baseUrl;
}
export function setBaseUrlFile(url) {
    baseUrlFile = url;
}
export function getBaseUrlFile() {
    return baseUrlFile;
}
export function setMhbaseUrl(url) {
    mhbaseUrl = url;
}
export function getMhbaseUrl() {
    return mhbaseUrl;
}
export function setNoticeBaseUrl(url) {
    noticeBaseUrl = url;
}
export function getNoticeBaseUrl() {
    return noticeBaseUrl;
}
export function setWorkflowBaseUrl(url) {
    workflowBaseUrl = url;
}
export function getWorkflowBaseUrl() {
    return workflowBaseUrl;
}

export function setAttachmentUrl(url) {
    attachmentUrl = url;
}
export function getAttachmentUrl() {
    return attachmentUrl;
}
 export {
     kkFileViewUrl,
     rootUrl,
     downloadUrl,
     uploadUrl,
     baseUrl,
     baseUrlFile,
     mhbaseUrl,
     noticeBaseUrl,
     workflowBaseUrl,
     iconfontUrl,
     iconfontVersion,
     codeUrl,
     env,
     attachmentUrl
 }
 


// WEBPACK FOOTER //
// ./src/config/env.js